import { GridActionsCellItem, GridActionsCellItemProps, GridColDef } from "@mui/x-data-grid";
import { Dispatch, SetStateAction } from "react";
import { TbQrcode } from "react-icons/tb";

import { WeTrackVehicleData } from "@/types/wetrack.types";

import { SetQrCodeVehicleType } from "../../types";

// function DeleteUserActionItem({ ...props }: GridActionsCellItemProps) {
//     return <GridActionsCellItem {...props} onClick={() => void 0} />;
// }

function PrintActionItem({ setQrCodeVehicle, ...props }: GridActionsCellItemProps & { setQrCodeVehicle: () => void }) {
    return (
        <>
            <GridActionsCellItem
                {...props}
                onClick={() => {
                    setQrCodeVehicle();
                }}
            />
        </>
    );
}

export const ActionsColumn = (
    setQrCodeVehicle: Dispatch<SetStateAction<SetQrCodeVehicleType | null>>
): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        field: "actions",
        type: "actions",
        width: 50,
        pinnable: true,
        cellClassName: "sticky right-0 z-50 bg-inherit ",
        headerClassName: "!sticky !right-0 z-50 bg-inherit ",
        getActions: (params) => [
            <PrintActionItem
                label="Driver"
                setQrCodeVehicle={() => {
                    setQrCodeVehicle({
                        vehicleId: params.row.vehicle_id.toString(),
                        plate: params.row.plate,
                    });
                }}
                showInMenu={false}
                icon={<TbQrcode />}
                color="primary"
            />,
            // <DeleteUserActionItem label="Delete" showInMenu icon={<TbTrash />} closeMenuOnClick={false} />,
        ],
    };
};
